var m = require('mithril');
var moment = require('moment');
var prop = require('mithril/stream');
var edit = require('../../layout/components/edit');
var dragscroll = require('../../libs/dragscroll');
var Model = require('../../libs/Model');
var session = require('../../auth/models/session');
var loaders = require('../../layout/components/loaders');
var io = require('../../libs/socketio');
var modal = require('../../layout/components/modal');
var button = require('../../components/button');
var modalForm = require('../../layout/components/modalForm');
var rowActionDropdown = require('../../components/rowActionDropdown');
var editFieldModal = require('../components/editFieldsModal');
var hoverableDropdownDiv = require('../../components/hoverableDropdownDiv');
var addCustomEquipmentModal = require('../addCustomEquipmentModal');
var addEquipmentPortModal = require('./addEquipmentPortModal');
var addFeedsEdgeModal = require('./addFeedsEdgeModal');
var pagination = require('../../data/components/pagination');
var equipmentModel = require('../models/equipment');
var ontologyFields = require('../../../../../models/equipment/ontologyFields');
var propertyFieldValue = require('./propertyFieldValue');
var reportsMenu = require('./reportsMenu');
var documentActions = require('./documentActions');
var pointDocument = modalForm(Object.assign(require('../../../../../models/documents/Document'), Model));
var dateFormat = 'MM/DD/YYYY';
var commentDateFormat = 'MM/DD/YYYY HH:mm';

var megaMenu = {};

function refreshEquipmentRecord(vnode, options) {
  if (!vnode || typeof vnode.attrs.submitCallback !== 'function') {
    return Promise.resolve();
  }

  return Promise.resolve(vnode.attrs.submitCallback()).catch(function () {
    if (options && options.silent) return;
    vnode.state.commentsError(options && options.errorMessage
      ? options.errorMessage
      : 'Comment saved, but failed to refresh the list.');
  });
}

function normalizeCommentsFromRecord(record) {
  if (!record) return [];
  const subjectOfArray = Array.isArray(record.out_SubjectOf) ? record.out_SubjectOf : [];
  return subjectOfArray.map(subjectOfRecord => {
    const commentRecord = subjectOfRecord.in || subjectOfRecord || {};
    const authorEdge = (commentRecord.out_AuthoredBy || subjectOfRecord.out_AuthoredBy || [])[0];
    const user = authorEdge && authorEdge.in ? authorEdge.in : {};
    return {
      '@rid': commentRecord['@rid'],
      '@class': commentRecord['@class'],
      message: commentRecord.message,
      timestamp: commentRecord.timestamp,
      updatedTimestamp: commentRecord.updatedTimestamp,
      deleted: commentRecord.deleted || false,
      user: {
        '@rid': user['@rid'],
        firstName: user.firstName || '',
        lastName: user.lastName || ''
      }
    };
  });
}

function sortComments(list) {
  return (Array.isArray(list) ? list.slice() : []).sort((a, b) => {
    const ta = a && a.timestamp ? a.timestamp : 0;
    const tb = b && b.timestamp ? b.timestamp : 0;
    return tb - ta;
  });
}

function buildCommentSignature(list) {
  return (Array.isArray(list) ? list : []).map(comment => {
    const rid = comment && comment['@rid'] ? comment['@rid'] : '';
    const timestamp = comment && (comment.updatedTimestamp || comment.timestamp) ? (comment.updatedTimestamp || comment.timestamp) : '';
    const message = comment && comment.message ? comment.message : '';
    return `${rid}:${timestamp}:${message}`;
  }).join('|');
}

megaMenu.oninit = function (vnode) {
  vnode.state.openDropdownId = null;
  vnode.state.lastCloseSignal = vnode.attrs.closeSignal;
  vnode.state.isStorageClass = equipmentModel.equipmentClassTree.equipment[vnode.attrs.equipmentRecord()['@class']] == 'Storage';
  vnode.state.classData = vnode.attrs.equipmentClassOntologyData();
  vnode.state.equipmentFields = ontologyFields.normalizeFieldDefinitions(
    vnode.state.classData && vnode.state.classData.data ? vnode.state.classData.data.fields : []
  );
  vnode.state.commentsToShow = [];
  vnode.state.commentsError = prop('');
  vnode.state.lastCommentsRid = null;
  vnode.state.lastCommentsSignature = null;
  vnode.state.commentText = prop('');
  vnode.state.commentSubmitting = prop(false);
  vnode.state.editingRid = prop(null);
  vnode.state.reinitializePagination = prop(false);
  vnode.state.networkHosts = prop([]);
  vnode.state.networkHostsLoading = prop(false);
  vnode.state.lastNetworkRid = null;
  vnode.state.commentSocketPending = false;
  vnode.state.commentSocketInFlight = false;
  vnode.state.commentSocketHandler = function (payload) {
    if (!payload || !payload.subjectRecord || !payload.subjectRecord['@rid']) return;
    const equipment = vnode.attrs.equipmentRecord && vnode.attrs.equipmentRecord();
    const equipmentRid = equipment && equipment['@rid'];
    if (!equipmentRid) return;
    if (payload.subjectRecord['@rid'].toString() !== equipmentRid.toString()) return;
    if (vnode.state.commentSocketInFlight) {
      vnode.state.commentSocketPending = true;
      return;
    }
    vnode.state.commentSocketInFlight = true;
    refreshEquipmentRecord(vnode, { silent: true })
      .finally(function () {
        vnode.state.commentSocketInFlight = false;
        if (vnode.state.commentSocketPending) {
          vnode.state.commentSocketPending = false;
          vnode.state.commentSocketHandler(payload);
        }
      });
  };
  io.on('comment-event', vnode.state.commentSocketHandler);
}

megaMenu.onremove = function (vnode) {
  if (vnode.state.commentSocketHandler) {
    io.off('comment-event', vnode.state.commentSocketHandler);
  }
}

megaMenu.onbeforeupdate = function (vnode) {
  vnode.state.classData = vnode.attrs.equipmentClassOntologyData();
  vnode.state.equipmentFields = ontologyFields.normalizeFieldDefinitions(
    vnode.state.classData && vnode.state.classData.data ? vnode.state.classData.data.fields : []
  );
}

megaMenu.view = function (vnode) {
  const equipmentRecord = vnode.attrs.equipmentRecord();
  const equipmentRid = equipmentRecord && equipmentRecord['@rid'];

  if (vnode.attrs.closeSignal !== undefined && vnode.attrs.closeSignal !== vnode.state.lastCloseSignal) {
    vnode.state.openDropdownId = null;
    vnode.state.commentsPageReady = false;
    vnode.state.lastCloseSignal = vnode.attrs.closeSignal;
  }

  const recordComments = sortComments(normalizeCommentsFromRecord(equipmentRecord));
  const commentSignature = buildCommentSignature(recordComments);

  if (equipmentRid && vnode.state.lastCommentsRid !== equipmentRid) {
    vnode.state.lastCommentsRid = equipmentRid;
    vnode.state.commentsToShow = JSON.parse(JSON.stringify(recordComments));
    vnode.state.commentText('');
    vnode.state.commentsError('');
    vnode.state.editingRid(null);
    vnode.state.reinitializePagination(true);
    vnode.state.lastCommentsSignature = commentSignature;
  } else if (equipmentRid && equipmentRecord && vnode.state.lastCommentsSignature !== commentSignature) {
    vnode.state.commentsToShow = JSON.parse(JSON.stringify(recordComments));
    vnode.state.reinitializePagination(true);
    vnode.state.lastCommentsSignature = commentSignature;
  }

  async function fetchNetworkHosts() {
    if (!equipmentRid || vnode.state.networkHostsLoading()) return;
    vnode.state.networkHostsLoading(true);
    try {
      const hosts = await loaders.requestWithLoader({
        url: `/api/v1/equipment/${equipmentRid.slice(1)}/hosts`,
        method: 'GET',
        background: true
      });
      vnode.state.networkHosts(Array.isArray(hosts) ? hosts : []);
    } catch (error) {
      vnode.state.networkHosts([]);
    } finally {
      vnode.state.networkHostsLoading(false);
    }
  }

  if (equipmentRid && vnode.state.lastNetworkRid !== equipmentRid) {
    vnode.state.lastNetworkRid = equipmentRid;
    fetchNetworkHosts();
  }

  function isOwner(commentRecord) {
    if (!commentRecord) return false;
    const currentUserRid = session.user && session.user()['@rid'];
    const authorRid = commentRecord.user && commentRecord.user['@rid'];
    return currentUserRid && authorRid && currentUserRid === authorRid;
  }

  async function addComment() {
    const message = (vnode.state.commentText() || '').trim();
    if (!message || !equipmentRid || vnode.state.commentSubmitting()) return;

    vnode.state.commentSubmitting(true);
    vnode.state.commentsError('');

    const payload = {
      subjectRecord: equipmentRid,
      timestamp: Date.now(),
      message
    };

    try {
      const editingRid = vnode.state.editingRid();
      if (editingRid) {
        await loaders.requestWithLoader({
          url: `/api/v1/comment/${editingRid.toString().replace('#', '')}`,
          method: 'PUT',
          body: { message, updatedTimestamp: payload.timestamp, elementRid: equipmentRid },
          loader: 'submit'
        });
        vnode.state.editingRid(null);
        vnode.state.commentText('');
        await refreshEquipmentRecord(vnode);
      } else {
        await loaders.requestWithLoader({
          url: '/api/v1/comment',
          method: 'POST',
          body: payload,
          loader: 'submit'
        });
        vnode.state.commentText('');
        await refreshEquipmentRecord(vnode);
      }
    } catch (error) {
      vnode.state.commentsError('Unable to add your comment. Please try again.');
    } finally {
      vnode.state.commentSubmitting(false);
      m.redraw();
    }
  }

  function confirmDeleteComment(commentRecord) {
    if (!commentRecord || !isOwner(commentRecord)) return;
    const message = commentRecord.message ? commentRecord.message.trim() : '';
    modal.vm.title('Delete comment?');
    modal.vm.body = function () {
      return m('div', [
        m('p', 'Are you sure you want to delete this comment?'),
        message ? m('div.mt3.pa2.br2.ba.b--dashed.b--dark-gray.bg-near-black', [
          m('div.white', message)
        ]) : null
      ]);
    };
    modal.vm.buttons([
      {
        label: 'Cancel',
        class: 'dib mr2',
        func: function () {
          modal.vm.close();
        }
      },
      {
        label: 'Delete',
        class: 'dib red',
        func: function () {
          return deleteComment(commentRecord).then(function () {
            modal.vm.close();
          });
        }
      }
    ]);
    modal.vm.open();
  }

  async function deleteComment(commentRecord) {
    if (!commentRecord || !isOwner(commentRecord)) return;
    const rid = commentRecord['@rid'];
    if (!rid) return;
    try {
      await loaders.requestWithLoader({
        url: `/api/v1/comment/${rid.toString().replace('#', '')}`,
        method: 'DELETE',
        body: { deletedTimestamp: Date.now(), elementRid: equipmentRid },
        loader: 'submit'
      });
      if (vnode.state.editingRid() === rid) {
        vnode.state.editingRid(null);
        vnode.state.commentText('');
      }
      await refreshEquipmentRecord(vnode);
    } catch (err) {
      vnode.state.commentsError('Unable to delete the comment. Please try again.');
    } finally {
      m.redraw();
    }
  }

  function refreshPaginationData() {
    vnode.state.commentsToShow = JSON.parse(JSON.stringify(recordComments || []));
    vnode.state.reinitializePagination(true);
  }

  function renderCommentsContent() {
    if (vnode.state.openDropdownId === 'menu-comments' && (!vnode.state.commentsToShow || !vnode.state.commentsToShow.length)) {
      refreshPaginationData();
    }
    const displayComments = vnode.state.commentsToShow || [];
    const commentId = `equipment-comment-${equipmentRid ? equipmentRid.replace('#', '') : 'new'}`;
    const canSubmit = Boolean((vnode.state.commentText() || '').trim()) && !vnode.state.commentSubmitting();

    return m('div.mv1.overflow-hidden', [
      vnode.state.commentsError() ? m('div.pa2.red', vnode.state.commentsError()) : '',
      m('div.dragscroll-container', {
        style: { 
          display: vnode.state.reinitializePagination() ? 'none' : '',
          minHeight: '286px'
        }
      }, [
        m('div.dragscroll.mega-menu-dragscroll', { oncreate: dragscroll }, [
          m('table.fw2.f3.w-100.pr3', { style: { minWidth: '900px' } }, [
            m('thead', [
              m('tr.relative', [
                m('th.br.tl.bt-0.bl-0.b--dotted.bw1', { style: { width: '50%' } }, 'Comment'),
                m('th.br.tl.bt-0.bl-0.b--dotted.bw1', { style: { width: '20%' } }, 'By'),
                m('th.br.tl.bt-0.bl-0.b--dotted.bw1', { style: { width: '20%' } }, 'Time'),
                m('th.br.tl.bt-0.bl-0.b--dotted.bw1', { style: { width: '10%' } }, 'Actions'),
              ])
            ]),
            m('tbody', (displayComments && displayComments.length ? displayComments : []).map(function (commentRecord) {
                const user = commentRecord.user || {};
                return m('tr', [
                  m('td.bb.tl.moon-gray.w-50', { style: { wordWrap: 'break-word', minWidth: '400px' } }, commentRecord.message || ''),
                  m('td.bb.tl.moon-gray.w-20', { style: { minWidth: '160px' } }, (user.firstName || '') + ' ' + (user.lastName || '')),
                  m('td.bb.tl.moon-gray.w-20', { style: { minWidth: '160px' } }, commentRecord.timestamp ? moment(new Date(commentRecord.timestamp)).format(commentDateFormat) : ''),
                  m('td.bb.tl.moon-gray.w-10', { style: { minWidth: '120px' } }, [
                    isOwner(commentRecord)
                      ? m(rowActionDropdown, {
                          align: 'right',
                          items: [
                            {
                              label: 'Edit Comment',
                              icon: 'ion-ios-compose',
                              onclick: function () {
                              vnode.state.editingRid(commentRecord['@rid']);
                              vnode.state.commentText(commentRecord.message || '');
                              }
                            },
                            {
                              label: 'Delete Comment',
                              icon: 'ion-ios-trash',
                              class: 'red',
                              onclick: function () { confirmDeleteComment(commentRecord); }
                            }
                          ]
                        })
                      : null
                  ])
                ]);
              })
            )
          ])
        ])
      ]),
      m('div.mt4', [
        m(pagination, { data: vnode.state.commentsToShow, reinitializePagination: vnode.state.reinitializePagination })
      ]),
      m('div.mt3', [
        m('label', { for: commentId }, vnode.state.editingRid() ? 'Edit comment:' : 'Add Comment:'),
        m('div.flex.mt2', [
          m('textarea', {
            id: commentId,
            rows: '4',
            cols: '40',
            'box-sizing': 'border-box',
            placeholder: 'Add your comment here...',
            oninput: function (ev) { vnode.state.commentText(ev.target.value); },
            value: vnode.state.commentText(),
            disabled: vnode.state.commentSubmitting()
          }),
          m('div.flex.flex-column', [              
            m('div.f4.ba.bw1.ph3.pv2.tc.v-btm.dib.ml2.items-center.mb2', {
              class: 'pointer b--red red',
              style: {
                visibility: vnode.state.editingRid() ? 'visible' : 'hidden'
              },
              onclick: function () {
                vnode.state.editingRid(null);
                vnode.state.commentText('');
              }
            }, m('i.ion-close-round.f1.red')),
            m('div.f4.ba.bw1.ph3.pv2.tc.v-btm.dib.ml2.items-center', {
              class: canSubmit ? 'pointer b--blue blue' : 'b--mid-gray mid-gray o-60',
              onclick: function () {
                if (canSubmit) addComment();
              }
            }, m('i.ion-android-send.f1'))
          ]),
          
        ])
      ])
    ]);
  }

  function toggleDropdown(dropdownId) {
    if (vnode.state.openDropdownId === dropdownId) {
      vnode.state.openDropdownId = null; // Close the dropdown if it's already open
      vnode.state.commentsPageReady = false;
    } else {
      openDropdown(dropdownId);
    }
  }

  function openDropdown(dropdownId) {
    const alreadyOpen = vnode.state.openDropdownId === dropdownId;
    vnode.state.openDropdownId = dropdownId; // Open the new dropdown
    if (!alreadyOpen && typeof vnode.attrs.onOpen === 'function') {
      vnode.attrs.onOpen(dropdownId);
    }
    if (!alreadyOpen && dropdownId === 'menu-comments') {
      refreshPaginationData();
    }
  }

  function handleMouseOver(dropdownId) {
    openDropdown(dropdownId);
  }

  function handleMouseOut() {
    vnode.state.openDropdownId = null;
  }

  function renderNetworkContent() {
    const hosts = vnode.state.networkHosts();
    if (vnode.state.networkHostsLoading()) {
      return m('div.mv2', 
          m('img', {
          src: '/images/loading-bars.svg',
          alt: 'Loading',
          style: { width: '3rem', height: 'auto' }
        })
      );
    }
    if (!hosts || !hosts.length) {
      return m('div.mv2', 'No connected hosts found.');
    }
    return m('div.mv1.overflow-hidden', [
      m('div.dragscroll-container', {
      style: { 
        minHeight: '286px'
      }
    }, [
      m('div.dragscroll.mega-menu-dragscroll', { oncreate: dragscroll }, [
        m('table.fw2.f3.w-100.pr3', { style: { minWidth: '400px' } }, [
          m('thead', [
            m('tr', [
              m('th.br.tl.bt-0.bl-0.b--dotted.bw1.fw2', { style: { width: '60%' } }, 'Host'),
              m('th.br.tl.bt-0.bl-0.b--dotted.bw1.fw2', { style: { width: '40%' } }, 'Class')
            ])
          ]),
          m('tbody', hosts.map(host => {
            const rid = host && host['@rid'] ? host['@rid'].toString() : '';
            const className = host && host['@class'] ? host['@class'] : '';
            const href = rid && className ? `/${className.toLowerCase()}/${rid.slice(1)}` : null;
            return m('tr', [
              m('td.bb.tl.moon-gray.nowrap', href ? m(m.route.Link, { href, class: 'blue dim' }, host && host.name ? host.name : '(unnamed host)') : (host && host.name ? host.name : '(unnamed host)')),
              m('td.bb.tl.moon-gray.nowrap', className)
            ]);
          }))
        ])
      ])
    ])
    ])
  }

  const ports = equipmentRecord.ports ? Object.values(equipmentRecord.ports) || [] : [];

  const incomingPorts = ports
    .filter(p => p.type == 'input')
    .filter(port => edit.vm.editing() || (equipmentRecord.in_Feeds || []).some(f => f.toPortId == port.id));

  const outgoingPorts = ports
    .filter(p => p.type == 'output')
    .filter(port => edit.vm.editing() || (equipmentRecord.out_Feeds || []).some(f => f.fromPortId == port.id));

  return m('div.mh3.mb2.justify-between.flex.flex-wrap', {
    style: {
      'position': 'relative'
    }
  }, [
    m('div.flex.flex-wrap', [
      m(hoverableDropdownDiv, {
        menuTitle: 'Properties',
        menuId: 'menu-properties',
        mainDivClass: '.mr2.mt2',
        isOpen: vnode.state.openDropdownId === 'menu-properties',
        toggleDropdown: toggleDropdown,
        onMouseOver: () => handleMouseOver('menu-properties'),
        onMouseOut: handleMouseOut,
        content: (vnode.state.equipmentFields && Array.isArray(vnode.state.equipmentFields) ? vnode.state.equipmentFields : []).map(field => {
          var fieldName = ontologyFields.getFieldName(field);
          var displayValue = propertyFieldValue.render(vnode.attrs.equipmentRecord(), field, { emptyText: '-' });
          return m('div.fl.w-100.w-50-ns.w-25-l.pa1', [
            m('div.flex.justify-between.bb.pa2', [
              m('div.mr1.nowrap.overflow-show', `${_.startCase(fieldName)}:`),
              edit.vm.editing() ?
                m('div.nowrap.truncate.overflow-hidden.blue', {
                  onclick: editFieldModal.editDialogue.bind(editFieldModal, vnode.attrs.equipmentRecord(), vnode.state.equipmentFields, { submitCallback: vnode.attrs.submitCallback }),
                }, displayValue)
                :
                m('div.nowrap.truncate.overflow-hidden', displayValue)
            ])
          ])
        }),
      }),
      m(hoverableDropdownDiv, {
        menuTitle: 'Documents',
        menuId: 'menu-documents',
        mainDivClass: '.mr2.mt2',
        isOpen: vnode.state.openDropdownId === 'menu-documents',
        toggleDropdown: toggleDropdown,
        onMouseOver: () => handleMouseOver('menu-documents'),
        onMouseOut: handleMouseOut,
        content: m('div.mv1', [
          m('div.dragscroll-container', {
            style: {
              'margin-right': '0px'
            }
          }, [
            m('div.dragscroll.mega-menu-dragscroll', { oncreate: dragscroll }, [
              m('table.fw2.f3.w-100.pr3', [
                m('thead', [
                  m('tr.relative', [
                    m('th.br.tl.bt-0.bl-0.b--dotted.bw1.fw2', { style: { width: '30%' } }, 'Name'),
                    m('th.br.tl.bt-0.bl-0.b--dotted.bw1.fw2', { style: { width: '30%' } }, 'Description'),
                    m('th.br.tl.bt-0.bl-0.b--dotted.bw1.fw2', { style: { width: '20%' } }, 'Date Uploaded'),
                    m('th.br.tl.bt-0.bl-0.b--dotted.bw1.fw2', { style: { width: '20%' } }, 'Actions')
                  ])
                ]),
                m('tbody', [
                  (vnode.attrs.equipmentRecord().out_AttachmentOf || []).map(function (documentRecord) {
                    return m('tr', [
                      m('td.bb.tl.moon-gray.tl.nowrap', documentRecord.in.name),
                      m('td.bb.tl.moon-gray.tl.nowrap', documentRecord.in.description),
                      m('td.bb.tl.moon-gray.tl.nowrap', moment(parseInt(documentRecord.in.uploadedDate)).format(dateFormat)),
                      m('td.bb.tl.moon-gray.tl.nowrap', documentActions.renderActions(documentRecord, {
                        submitCallback: vnode.attrs.submitCallback
                      }))
                    ])
                  })
                ])
              ])
            ])
          ]),
          m('div.cf', [
            session.user().isSuperuser ? m(button, {
              label: 'Add Document',
              class: 'w5 mh3 mv4 fr',
              func: pointDocument.editDialogue.bind(pointDocument, { parent: vnode.attrs.equipmentRecord()['@rid'].slice(1) }, { submitCallback: vnode.attrs.submitCallback }),
            })
              : ''
          ])
        ])
      }),
      m(hoverableDropdownDiv, {
        menuTitle: 'Comments',
        menuId: 'menu-comments',
        mainDivClass: '.mr2.mt2',
        isOpen: vnode.state.openDropdownId === 'menu-comments',
        toggleDropdown: toggleDropdown,
        onMouseOver: () => handleMouseOver('menu-comments'),
        onMouseOut: handleMouseOut,
        content: renderCommentsContent()
      }),
      vnode.state.isStorageClass ?
        m(hoverableDropdownDiv, {
          menuTitle: 'Maintenance',
          menuId: 'menu-maintenance',
          mainDivClass: '.mr2',
          isOpen: vnode.state.openDropdownId === 'menu-maintenance',
          toggleDropdown: toggleDropdown,
          onMouseOver: () => handleMouseOver('menu-maintenance'),
          onMouseOut: handleMouseOut,
          content: m('div', [
            m('div.fl.w-100.w-50-ns.w-50-l.mb3', [
              m(m.route.Link, { href: `/equipment/${vnode.attrs.equipmentRecord()['@class']}/${vnode.attrs.equipmentRecord()['@rid'].slice(1)}/calibration` }, [
                m('div.flex.justify-between.items-center.ba.b--mid-gray.bw1.pa2.f6.mh1', [
                  m('p.pa0.ma0', 'Calibration'),
                  m('i.icon.ion-ios-arrow-right')
                ]),
              ])
            ])
          ])
        })
        : '',
      m(reportsMenu, {
        location: vnode.attrs.equipmentRecord,
        equipmentAllRids: prop([vnode.attrs.equipmentRecord()]),
      }),
      edit.vm.editing() ?
        [
          m('div.f4', [
            m('div.ba.b--blue.b--dashed.bw1.ph1.h2.flex.items-center.mt2', {
              onclick: addCustomEquipmentModal.editDialogue.bind(addCustomEquipmentModal, undefined, undefined, vnode.attrs.equipmentRecord(), { submitCallback: vnode.attrs.submitCallbackAddingEquipment })
            }, [
              m('div.flex.justify-center.blue', [
                m('i.ion-plus.mr2'),
                m('div', 'Add Equipment')
              ])
            ])
          ])
        ]
        : ''
    ]),
    m('div.flex.mt2', [
      m(hoverableDropdownDiv, {
        menuTitle: 'Network',
        menuId: 'menu-network',
        mainDivClass: '.mr2',
        isOpen: vnode.state.openDropdownId === 'menu-network',
        toggleDropdown: toggleDropdown,
        onMouseOver: () => handleMouseOver('menu-network'),
        onMouseOut: handleMouseOut,
        content: renderNetworkContent()
      }),
      m(hoverableDropdownDiv, {
        menuTitle: 'Connections',
        menuId: 'menu-ports',
        isOpen: vnode.state.openDropdownId === 'menu-ports',
        toggleDropdown: toggleDropdown,
        onMouseOver: () => handleMouseOver('menu-ports'),
        onMouseOut: handleMouseOut,
        content: m('div.w-100', [
          (edit.vm.editing() || incomingPorts.length
            ? [
              m('div.pv1.tc.f4.w-100', 'Incoming'),
              m('div.w-100', [
                incomingPorts.map(port => {
                  const inEdges = (equipmentRecord.in_Feeds || []).filter(f => f.toPortId == port.id);

                  return m('div.ba.b--blue.grid-item.w-100.ph2.pv1.overflow-hidden.mv2', [
                    m('div.dragscroll-container', [
                      m('div.dragscroll.mega-menu-dragscroll.mr4', { oncreate: dragscroll }, [
                        m('div.bw1.pb4.pt2.flex', [
                          m('div.mr2.nowrap', port.name),
                          m('div.flex.flex-column.w-100',
                            inEdges.map((edge) => {
                              return m('div.flex.items-start', { style: { whiteSpace: 'nowrap' } }, [
                                m('div.blue.mr2.pointer', {
                                  onclick: () => {
                                    if (edit.vm.editing()) {
                                      addFeedsEdgeModal.editDialogue(edge, vnode.attrs.equipmentRecord(), port, { submitCallback: vnode.attrs.initAndRedrawDiagram, invertEquipment: true });
                                    } else {
                                      m.route.set(`/equipment/${edge.out['@class']}/${edge.out['@rid'].slice(1)}`);
                                    }
                                  }
                                }, `${edge.out.name || edge.out['@class']}`),

                                // optional: show path(s) for this edge
                                edge.feedsPaths && edge.feedsPaths.length
                                  ? m('div', edge.feedsPaths.map((feedsPath) => {
                                    if (!feedsPath || !feedsPath['@rid'] || !feedsPath.path || !feedsPath.path.length) return null;
                                    const nodes = feedsPath.path.filter(node => node && node['@rid'] && node['@rid'] !== edge.out['@rid']);
                                    if (!nodes.length) return null;
                                    return m('div.flex.items-start', [
                                      m('div', '•'),
                                      m('div.flex', { style: { flexWrap: 'nowrap' } }, nodes.map((node, idx) => (
                                        m('div.flex.items-end', [
                                          edit.vm.editing() ?
                                            m('div.pointer.mh2.blue', {
                                              onclick: () => {
                                                addFeedsEdgeModal.editDialogue(undefined, vnode.attrs.equipmentRecord(), port, { submitCallback: vnode.attrs.initAndRedrawDiagram, invertEquipment: true });
                                              }
                                            },  node.name || node['@class'])
                                          : 
                                            m(m.route.Link, {
                                              href: `/equipment/${node['@class'].toLowerCase()}/${node['@rid'].slice(1)}`,
                                              class: 'mh2'
                                            }, node.name || node['@class']),
                                          
                                          idx < nodes.length - 1 ? ' / ' : ''
                                        ])
                                      )))
                                    ]);
                                  }))
                                  : null
                              ]);
                            })
                          ),
                          (edit.vm.editing()
                            ? m('i.ion-plus.blue.pointer.ml1', {
                              onclick: addFeedsEdgeModal.editDialogue.bind(
                                addFeedsEdgeModal,
                                undefined,
                                vnode.attrs.equipmentRecord(),
                                port,
                                { submitCallback: vnode.attrs.initAndRedrawDiagram, invertEquipment: true }
                              )
                            })
                            : '')
                        ])
                      ])
                    ])
                  ]);
                })
              ])
            ]
            : ''),

          (edit.vm.editing() || outgoingPorts.length
            ? [
              m('div.pv1.tc.f4.w-100.mt3', 'Outgoing'),
              m('div.w-100', [
                outgoingPorts.map(port => {
                  const outEdges = (equipmentRecord.out_Feeds || []).filter(f => f.fromPortId == port.id);

                  return m('div.ba.b--blue.grid-item.w-100.ph2.pv1.overflow-hidden.mv2', [
                    m('div.dragscroll-container', [
                      m('div.dragscroll.mega-menu-dragscroll.mr4', { oncreate: dragscroll }, [
                        m('div.bw1.pb4.pt2.flex', [
                          m('div.mr2.nowrap', port.name),
                          m('div.flex.flex-column.w-100',
                            outEdges.map((edge) => m('div.flex.items-start', { style: { whiteSpace: 'nowrap' } }, [
                              m('div.blue.mr2.pointer', {
                                onclick: () => {
                                  if (edit.vm.editing()) {
                                    addFeedsEdgeModal.editDialogue(edge, vnode.attrs.equipmentRecord(), port, { submitCallback: vnode.attrs.initAndRedrawDiagram });
                                  } else {
                                    m.route.set(`/equipment/${edge.in['@class']}/${edge.in['@rid'].slice(1)}`);
                                  }
                                }
                              }, `${edge.in.name || edge.in['@class']}`),

                              edge.feedsPaths && edge.feedsPaths.length
                                ? m('div', edge.feedsPaths.map((feedsPath) => {
                                  if (!feedsPath || !feedsPath['@rid'] || !feedsPath.path || !feedsPath.path.length) return null;
                                  const nodes = feedsPath.path.filter(node => node && node['@rid'] && node['@rid'] !== edge.in['@rid']);
                                  if (!nodes.length) return null;
                                  return m('div.flex.items-start', [
                                    m('div', '•'),
                                    m('div.flex', { style: { flexWrap: 'nowrap' } }, nodes.map((node, idx) => (
                                      m('div.flex.items-center', [
                                        edit.vm.editing() ?
                                        m('div.pointer.mh2.blue', {
                                          onclick: () => {
                                            addFeedsEdgeModal.editDialogue(undefined, vnode.attrs.equipmentRecord(), port, { submitCallback: vnode.attrs.initAndRedrawDiagram });
                                          }
                                        }, node.name || node['@class'])
                                      :
                                        m(m.route.Link, {
                                          href: `/equipment/${node['@class'].toLowerCase()}/${node['@rid'].slice(1)}`,
                                          class: 'mh2'
                                        }, node.name || node['@class']),
                                        
                                      idx < nodes.length - 1 ? ' / ' : ''
                                      ])
                                    )))
                                  ]);
                                }))
                                : null
                            ]))
                          ),
                          (edit.vm.editing()
                            ? m('i.ion-plus.blue.pointer.ml1', {
                              onclick: addFeedsEdgeModal.editDialogue.bind(
                                addFeedsEdgeModal,
                                undefined,
                                vnode.attrs.equipmentRecord(),
                                port,
                                { submitCallback: vnode.attrs.initAndRedrawDiagram }
                              )
                            })
                            : '')
                        ])
                      ])
                    ])
                  ]);
                }),
                edit.vm.editing() ?
                  m('div.w-100.pv1', [
                    m('div.ba.b--blue.b--dashed.bw1.pa2', {
                      onclick: () => addEquipmentPortModal.editDialogue(vnode.attrs.equipmentRecord(), vnode.attrs.findRightmostNode(vnode.attrs.diagram()), { submitCallback: vnode.attrs.initAndRedrawDiagram })
                    }, [
                      m('div.flex.justify-center.blue', [
                        m('i.ion-plus.mr2'),
                        m('div', 'Add Port')
                      ])
                    ])
                  ])
                  : ''
              ])
            ]
            : '')
        ])
      })
    ])
  ])
}


module.exports = megaMenu;
